<template lang="pug">
.new-temporaryStock
  shForm(title="Nuevo Inventario Temporal")
</template>

<script>
import shForm from '@/components/pages/temporaryStock/Form'

export default {
  name: 'NewTemporaryStock',

  components: { shForm }
}
</script>

<style lang="stylus">
.new-temporaryStock
  position relative
</style>



// WEBPACK FOOTER //
// src/components/pages/temporaryStock/New.vue